import React, { useEffect, useState, useRef, memo } from 'react';
import './Tile.css';
import { CircleDollarSign, Ghost } from 'lucide-react'; 

function Tile({ shouldPop, tileType = "blank", wallVariant = "normal", isHidden = false, skinId = "tile_default" }) {
    const [pop, setPop] = useState(false);
    const [isFaded, setIsFaded] = useState(false);
    
    // Wall morphing animation
    const [displayVariant, setDisplayVariant] = useState(wallVariant);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const timeoutRef = useRef(null);

    useEffect(() => {
        if (shouldPop > 0) {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            setPop(true);
            timeoutRef.current = setTimeout(() => {
                setPop(false);
                timeoutRef.current = null;
            }, 450);
        }
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [shouldPop]);

    useEffect(() => {
        if (wallVariant !== displayVariant) {
            setIsTransitioning(true);
            const t = setTimeout(() => {
                setDisplayVariant(wallVariant);
                setIsTransitioning(false); 
            }, 300); 
            return () => clearTimeout(t);
        }
    }, [wallVariant, displayVariant]);

    useEffect(() => {
        if (tileType === 'wall' && isHidden) {
            setIsFaded(false);
            const fadeTimer = setTimeout(() => {
                setIsFaded(true);
            }, 500); 
            return () => clearTimeout(fadeTimer);
        } else {
            setIsFaded(false);
        }
    }, [tileType, isHidden]);

    const getTileClasses = () => {
        const classes = ['tile'];
        
        if (tileType === 'wall') {
            if (displayVariant === 'lava') {
                classes.push('lava-tile');
            } else {
                classes.push('wall-tile');
                // Apply Skin Class only to normal walls
                if (skinId && skinId !== 'tile_default') {
                    // Convert id (e.g. "tile_frozen") to class name (e.g. "tile-skin-frozen")
                    if (skinId.startsWith('tile_')) {
                         const skinName = skinId.replace('tile_', '');
                         classes.push(`tile-skin-${skinName}`);
                    } else {
                        // Fallback or explicit mapping if ID structure changes
                        classes.push(skinId); 
                    }
                }
            }

            if (isHidden) {
                classes.push('wall-hidden-variant');
                if (isFaded) classes.push('faded');
            }
            
            if (isTransitioning) {
                classes.push('transitioning');
            }

        } else if (tileType === 'goal') {
            classes.push('goal-tile');
        } else if (tileType === 'ghost') { 
            classes.push('ghost-tile');
        } else if (tileType === 'coin') {
            classes.push('coin-tile');
        }
        
        if (pop) {
            classes.push('pop');
        }
        
        return classes.join(' ');
    };

    const iconStyle = {
        width: 'calc(var(--tile-size, 40px) * 0.60)',
        height: 'calc(var(--tile-size, 40px) * 0.60)',
        minWidth: 'calc(var(--tile-size, 40px) * 0.60)', 
        minHeight: 'calc(var(--tile-size, 40px) * 0.60)'
    };

    return (
        <div className={getTileClasses()}>
            {tileType === 'coin' && (
                <CircleDollarSign className="coin-icon" strokeWidth={2.5} style={iconStyle} />
            )}
            {tileType === 'ghost' && (
                <Ghost className="ghost-icon" strokeWidth={2} style={iconStyle} />
            )}
        </div>
    );
}
export default memo(Tile);